import type { City, CitySlug } from '@/types'

export const cities: Array<City> = [
    {
        slug: 'delhi',
        name: "Delhi",
        code: 'DEL',
        context: "Delhi's businesses range from corporate offices in Connaught Place and Jasola to trading firms, CA practices and SMEs in Nehru Place, Okhla and West Delhi.",
        localities: [
            "Connaught Place",
            "Nehru Place",
            "Okhla Industrial Area",
            "Jasola",
            "Saket",
            "Karol Bagh",
            "Rajouri Garden",
            "Janakpuri",
            "Pitampura",
            "Mayapuri"
        ]
    },
    {
        slug: 'noida',
        name: "Noida",
        code: 'NOI',
        context: "Noida is one of NCR's busiest IT and ITeS hubs, with tech companies, media houses and startups spread across Sector 62, Sector 63, Film City and the Noida Expressway.",
        localities: [
            "Sector 62",
            "Sector 63",
            "Sector 18",
            "Film City",
            "Noida Expressway",
            "Sectors 142 to 144",
            "Phase 2 Industrial Area",
            "Sectors 1 to 11"
        ]
    },
    {
        slug: 'greater-noida',
        name: "Greater Noida",
        code: 'GNO',
        context: "Greater Noida combines industrial units in Ecotech and Kasna, colleges and institutes in Knowledge Park, and fast-growing offices in Greater Noida West.",
        localities: [
            "Knowledge Park",
            "Pari Chowk",
            "Greater Noida West",
            "Ecotech industrial areas",
            "Kasna",
            "Techzone 4",
            "Alpha and Beta sectors",
            "Surajpur"
        ]
    },
    {
        slug: 'ghaziabad',
        name: "Ghaziabad",
        code: 'GZB',
        context: "Ghaziabad's manufacturers in Sahibabad and along Meerut Road, and its growing commercial hubs in Indirapuram, Vaishali and Raj Nagar Extension, all run on dependable office IT.",
        localities: [
            "Sahibabad Industrial Area",
            "Indirapuram",
            "Vaishali",
            "Kaushambi",
            "Raj Nagar Extension",
            "Mohan Nagar",
            "Kavi Nagar",
            "Meerut Road Industrial Area"
        ]
    },
    {
        slug: 'gurugram',
        name: "Gurugram",
        code: 'GGN',
        context: "Gurugram is home to multinational offices, startups and shared workspaces across Cyber City, Udyog Vihar, Golf Course Road and Sohna Road.",
        localities: [
            "Cyber City",
            "Udyog Vihar",
            "Golf Course Road",
            "Sohna Road",
            "MG Road",
            "Golf Course Extension Road",
            "Sector 44",
            "Manesar"
        ]
    },
    {
        slug: 'faridabad',
        name: "Faridabad",
        code: 'FBD',
        context: "Faridabad is one of NCR's major manufacturing centres, with factories and offices along Mathura Road, in NIT and across the sector industrial areas.",
        localities: [
            "NIT Faridabad",
            "Mathura Road",
            "Sector 15",
            "Ballabgarh",
            "Sector 24 industrial area",
            "Greater Faridabad",
            "Old Faridabad"
        ]
    }
]

export const cityNames: Array<string> = cities.map((city) => city.name)

export const getCity = (slug: string): City | undefined => cities.find((city) => city.slug === slug)

export const isCitySlug = (value: string): value is CitySlug => cities.some((city) => city.slug === value)

export const joinList = (items: Array<string>): string => {
    if (items.length <= 1) return items.join('')
    return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`
}

export const keyLocalities = (city: City): string => joinList(city.localities.slice(0, 4))
